import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { LucideAngularModule, ListPlus, Info, X } from 'lucide-angular';
@Component({
  selector: 'lib-add-bulk-options-dialog',
  imports: [MatDialogModule, FormsModule, MatButtonModule, MatInputModule,LucideAngularModule],
  templateUrl: './add-bulk-options-dialog.html',
  styleUrl: './add-bulk-options-dialog.css',
})
export class AddBulkOptionsDialog {
  private dialogRef = inject(MatDialogRef<AddBulkOptionsDialog>);
  bulkText = '';

  readonly ListPlusIcon = ListPlus;
  readonly InfoIcon = Info;
  readonly CloseIcon = X;

  close() {
    this.dialogRef.close();
  }

  submit() {
    if (this.bulkText.trim()) {
      this.dialogRef.close(this.bulkText);
    }
  }
}
